module.exports = __webpack_public_path__ + "img/ic-photo.e547d36a.svg";